import React from "react";
import { MedicationDecisionResult } from "../../../../../../data-model/cmmOrderTableRowData";
import NewDetailsCard from "../../../../../newDetailsCard/newDetailsCard";

interface MedicationThinkingCardProps {
  decision: MedicationDecisionResult;
}

/**
 * Displays similarity score and match reasoning from the medication decision.
 */
const MedicationThinkingCard: React.FC<MedicationThinkingCardProps> = ({
  decision,
}) => (
  <div className="rounded-xl bg-white p-4">
    <div className="mb-4 text-sm font-bold text-primaryGray-1">
      Medication Thinking
    </div>
    <div className="flex flex-wrap gap-y-4">
      <div className="w-1/2">
        <NewDetailsCard
          header="Similarity Score"
          body={
            decision.similarity_score != null
              ? String(decision.similarity_score)
              : "--"
          }
        />
      </div>
      <div className="w-1/2">
        <NewDetailsCard
          header="Match Reason"
          body={decision.match_reason || "--"}
        />
      </div>
    </div>
  </div>
);

export default MedicationThinkingCard;
